import { alertService } from 'components/Varios/alert_service';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import React, { useCallback, useState, useMemo } from 'react';
import { useTable, Column, Accessor, HeaderGroup, useGlobalFilter, usePagination, useSortBy, useRowSelect } from "react-table";
import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';

import {
    AprobarParcialmenteSolicitudVacaciones, DirectivoAprobadorObtenerVistaPreviaFormularioVacaciones,
    DirectivoAprobadorObtenerVistaPreviaFormularioAnulacionVacaciones, DirectivoAprobadorObtenerVistaPreviaFormularioReintegroVacaciones,
    AprobarSolicitudVacaciones, RechazarSolicitudVacaciones, AprobarAnulacionVacaciones,
    RechazarSolicitudAnulacionVacaciones, RechazarSolicitudReintegroVacaciones, AprobarReintegroVacaciones,
    AprobarMasivaSolicitudVacaciones, DirectivoAprobadorObtenerVistaPreviaFormularioReplanificacionVacaciones, ObtenerDetalleSolicitudReplanificacion, AprobarReplanificacionVacaciones, AprobarParcialmenteReplanificacionVacaciones,
    RechazarSolicitudReplanificacionVacaciones
} from './FunctionsAprobacionSolicitudes';

import { EstadoSolicitudReplanificacionVacaciones, EstadoSolicitudVacaciones, TipoFiltroSolicitudAprobar, TipoSolicitud } from './TypesAprobacionSolicitudes';

import ModalRechazo from "./ModalRechazoSolicitud"
import { FormGroup } from 'react-bootstrap';
import { authenticationService } from 'services/authentication.service';


import PDFViewer from "components/Varios/PDFViewer";
import Cargando from 'components/Varios/Cargando';
import ModalCargando from 'components/Varios/ModalCargando';
import { Checkbox } from 'components/Varios/Tabla/CheckBoxTable';

import "../../../assets/scss/TablaAprobacionSolicitudesMasivas.scss";
import ButtonAprobarMasivo from 'components/Varios/ButtonAprobarMasivo';

//ICONOS PARA ACCIONES
import { ReactComponent as Aprobar } from "assets/icons/Check.svg"
import { ReactComponent as Negar } from "assets/icons/X.svg"

import ExitoSVG from "assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "assets/icons/Permisos/Error.svg"

import Swal from 'sweetalert2'


export default function TableSolicitudesAprobar({ dataprops, recargarInformacionTabla, tipoFiltroSolicitud, filtrarTiposSolicitud }) {



    const TITULO_MODAL_APROBAR_PARCIAL_SOLICVAC = "Aprobación Parcial Solicitud de Vacaciones";
    const TITULO_MODAL_APROBAR_PARCIAL_PERMISOVAC = "Aprobación Parcial Solicitud Permiso imputable a Vacaciones";
    const TITULO_MODAL_PERMISO_IMPUTABLE = "Solicitud Permiso Imputable a Vacaciones"
    const TITULO_MODAL_SOLICITUD_VACACIONES = "Solicitud Vacaciones";


    const TIPO_SOLICITUDES_APROBAR_MASIVAMENTE = [TipoSolicitud.VACACIONES, TipoSolicitud.PERMISOCARGOVACACIONES,TipoSolicitud.REINTEGROVACACIONES, TipoSolicitud.ANULACIONVACACIONES, TipoSolicitud.REPLANIFICACIONVACACIONES]
    const TIPO_SOLICITUDES_PERMISOS_VACACIONES = [TipoSolicitud.VACACIONES, TipoSolicitud.PERMISOCARGOVACACIONES]
    const defaultStateInformacionModalAprobarVacaciones = {
        url: "",
        cargando: false,
        idSolicitudVacaciones: -1,
        modalContent: undefined,
        tituloModal: "Solicitud Vacaciones"
    }

    const defaultStateInformacionModalAprobarParcialmenteVacaciones = {
        tituloModal: "Aprobación Parcial Solicitud de Vacaciones",
        cargando: false,
        idSolicitudVacaciones: -1,
        contentBody: undefined
    }


    const defaultStateInformacionModalRechazarVacaciones = {

        cargando: false,
        idSolicitudVacaciones: -1,
        contentBody: undefined,
        observacion: ""
    }

    const defaultSateInformacionModalAnularVacaciones = {
        cargando: false,
        idSolicitudVacaciones: -1,
        contentBody: undefined
    }


    const defaultSateInformacionModalRechazarAnularVacaciones = {
        cargando: false,
        idSolicitudVacaciones: -1,
        contentBody: undefined
    }

    const defaultSateInformacionModalAprobarReintegroVacaciones = {
        cargando: false,
        idSolicitudReintegro: -1,
        contentBody: undefined
    }

    const defaultSateInformacionModalRechazarReintegroVacaciones = {
        cargando: false,
        idSolicitudReintegro: -1,
        contentBody: undefined
    }

    const defaultSateModalAprobacionMasivaSolicitudVacaciones = {
        cargando: false,
        listadoSolicitudesAprobar: [],
        contentBody: undefined
    }


    const defaultSateInformacionModalAprobarReplanificacionVacaciones = {
        cargando: false,
        idSolicitudReplanificacion: -1,
        contentBody: undefined
    }

    const defaultStateInformacionModalAprobarParcialmenteReplanificacionVacaciones = {
        tituloModal: "Aprobación Parcial Solicitud Reprogramación y/o Justificación",
        cargando: false,
        idSolicitudReplanificacion: -1,
        contentBody: undefined
    }

    const defaultStateInformacionModalRechazarReplanificacionVacaciones = {
        tituloModal: "Negar Solicitud Reprogramación y/o Justificación",
        cargando: false,
        idSolicitudReplanificacion: -1,
        contentBody: undefined,
        observacion: ""
    }



    const [stateinformacionModalAprobarVacaciones, setstateinformacionModalAprobarVacaciones] = useState(defaultStateInformacionModalAprobarVacaciones)
    const [stateinformacionModalAprobarParcialmenteVacaciones, setstateinformacionModalAprobarParcialmenteVacaciones] = useState(defaultStateInformacionModalAprobarParcialmenteVacaciones)
    const [stateinformacionModalRechazarVacaciones, setstateinformacionModalRechazarVacaciones] = useState(defaultStateInformacionModalRechazarVacaciones)
    const [stateinformacionModalAnularVacaciones, setstateinformacionModalAnularVacaciones] = useState(defaultSateInformacionModalAnularVacaciones)
    const [stateinformacionModalRechazarAnularVacaciones, setstateinformacionModalRechazarAnularVacaciones] = useState(defaultSateInformacionModalRechazarAnularVacaciones)
    const [stateinformacionModalAprobarReintegroVacaciones, setstateinformacionModalAprobarReintegroVacaciones] = useState(defaultSateInformacionModalAprobarReintegroVacaciones)
    const [stateinformacionModalRechazarReintegroVacaciones, setstateinformacionModalRechazarReintegroVacaciones] = useState(defaultSateInformacionModalRechazarReintegroVacaciones)
    const [stateinformacionModalAprobarReplanificacion, setstateinformacionModalAprobarReplanificacion] = useState(defaultSateInformacionModalAprobarReplanificacionVacaciones)
    const [stateinformacionModalAprobarParcialmenteReplanificacion, setstateinformacionModalAprobarParcialmenteReplanificacion] = useState(defaultStateInformacionModalAprobarParcialmenteReplanificacionVacaciones)
    const [stateinformacionModalRechazarReplanificacion, setstateinformacionModalRechazarReplanificacion] = useState(defaultStateInformacionModalAprobarParcialmenteReplanificacionVacaciones)

    //Aprobacion Masiva
    const [stateModalAprobacionMasivaSolicitudVacaciones, setstateModalAprobacionMasivaSolicitudVacaciones] = useState(defaultSateModalAprobacionMasivaSolicitudVacaciones)

    const [observacion, setobservacion] = useState("")
    const data = React.useMemo(
        () => [...dataprops], [dataprops]
    )

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }


    async function OnClickAccionModalFormulario(idSolicitudVacaciones) {
        setstateinformacionModalAprobarVacaciones({ cargando: true })
        var accionRealizada = await AprobarSolicitudVacaciones(idSolicitudVacaciones)
        setstateinformacionModalAprobarVacaciones(defaultStateInformacionModalAprobarVacaciones)
        await recargarInformacionTabla();
    }

    async function onClickAprobarSolicitudVacaciones(informacionAcciones) {
        setstateinformacionModalAprobarVacaciones({ ...defaultStateInformacionModalAprobarVacaciones, cargando: true })

        var respuesta = await DirectivoAprobadorObtenerVistaPreviaFormularioVacaciones(informacionAcciones.idSolicitud);



        if (respuesta.status === 200) {

            const tituloModal = informacionAcciones.permisoCargoVacaciones ? TITULO_MODAL_PERMISO_IMPUTABLE : TITULO_MODAL_SOLICITUD_VACACIONES;

            setstateinformacionModalAprobarVacaciones({
                url: respuesta.dataResponse,
                cargando: false,
                idSolicitudVacaciones: informacionAcciones.idSolicitud,
                modalContent: AuxiliarGenerarHTMLBodyModalInformacionVacacionesPendientes(informacionAcciones),
                tituloModal

            })
        }
        else {
            setstateinformacionModalAprobarVacaciones(defaultStateInformacionModalAprobarVacaciones)
            //alertService.error(respuesta.errorMessage ?? "No pudo obtenerse la vista Previa de Solicitud de Vacaciones");
            showAlert(respuesta.errorMessage ?? "No pudo obtenerse la vista Previa de Solicitud de Vacaciones", ErrorSVG, true);
        }
    }


    function onClickAprobarParcialmenteSolicitudVacaciones(informacionAcciones) {

        // const contentBody = (
        //     <>
        //         <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
        //             <thead className="cabecerasDetallehistorialSolic">
        //                 <tr className="" >
        //                     <th> Nombre</th>
        //                     <th> Fecha Desde</th>
        //                     <th> Fecha Hasta</th>
        //                     <th> Estado</th>
        //                     <th> Días Ordinarios</th>

        //                 </tr>
        //             </thead>
        //             <tbody>

        //                 <tr className="rowHistorialSolicitudVacaciones">
        //                     <td className="">
        //                         <div className="">
        //                             {informacionAcciones.nombres}
        //                         </div>

        //                     </td>
        //                     <td className="">
        //                         <div className="">
        //                             {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
        //                         </div>

        //                     </td>
        //                     <td className="">
        //                         <div className="">
        //                             {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
        //                         </div>

        //                     </td>

        //                     <td className="">
        //                         <div className="">
        //                             {informacionAcciones.estadoParse}
        //                         </div>

        //                     </td>


        //                     <td className="">
        //                         <div className="">
        //                             {informacionAcciones.diaOrdinario + " día(s) ordinario(s)"}
        //                         </div>

        //                     </td>

        //                 </tr>

        //             </tbody>
        //         </Table>
        //         {
        //             informacionAcciones.observacion && informacionAcciones.observacion !== "" &&
        //             <Container>
        //                 <Row>
        //                     <Col>
        //                         <FormGroup>
        //                             <Label>Justificación/Motivo</Label>
        //                             <Input
        //                                 id="observacionRechazo"
        //                                 name="observacionRechazo"
        //                                 type="textarea"
        //                                 rows="5"
        //                                 value={informacionAcciones.observacion}
        //                                 readOnly
        //                                 maxLength={500}
        //                             />
        //                         </FormGroup>
        //                     </Col>
        //                 </Row>
        //             </Container>
        //         }


        //     </>

        // )

        const contentBody = AuxiliarGenerarHTMLBodyModalVacaciones(informacionAcciones);
        const tituloModal = informacionAcciones.permisoCargoVacaciones ? TITULO_MODAL_APROBAR_PARCIAL_PERMISOVAC : TITULO_MODAL_APROBAR_PARCIAL_SOLICVAC


        setstateinformacionModalAprobarParcialmenteVacaciones({
            cargando: false,
            idSolicitudVacaciones: informacionAcciones.idSolicitud,
            contentBody,
            tituloModal: tituloModal
        })
    }


    async function onClickAnularSolicitudVacacionesAprobada(informacionAcciones) {

        setstateinformacionModalAnularVacaciones({
            ...stateinformacionModalAnularVacaciones,
            cargando: true,

        })
        const respuestaUrlFormulario = await DirectivoAprobadorObtenerVistaPreviaFormularioAnulacionVacaciones(informacionAcciones.idSolicitud);
        if (respuestaUrlFormulario.status === 200) {
            const contentBody = (
                <>

                    <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                        <thead className="cabecerasDetallehistorialSolic">
                            <tr className="" >
                                <th> Nombre</th>
                                <th> Fecha Desde</th>
                                <th> Fecha Hasta</th>
                                <th> Estado</th>
                                <th> Días Ordinarios</th>

                            </tr>
                        </thead>
                        <tbody>

                            <tr className="rowHistorialSolicitudVacaciones">
                                <td className="">
                                    <div className="">
                                        {informacionAcciones.nombres}
                                    </div>

                                </td>
                                <td className="">
                                    <div className="">
                                        {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                    </div>

                                </td>
                                <td className="">
                                    <div className="">
                                        {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
                                    </div>

                                </td>

                                <td className="">
                                    <div className="">
                                        {informacionAcciones.estadoParse}
                                    </div>

                                </td>


                                <td className="">
                                    <div className="">
                                        {informacionAcciones.diaOrdinario + " día(s) ordinario(s)"}
                                    </div>

                                </td>

                            </tr>

                        </tbody>
                    </Table>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Observación/Motivo</Label>
                                <Input
                                    id="observacionRechazo"
                                    name="observacionRechazo"
                                    type="textarea"
                                    rows="5"
                                    value={informacionAcciones.observacion}
                                    readOnly
                                    maxLength={500}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PDFViewer url={respuestaUrlFormulario.dataResponse} heightValue={"100%"} />

                        </Col>
                    </Row>
                </>

            )
            setstateinformacionModalAnularVacaciones({
                idSolicitudVacaciones: informacionAcciones.idSolicitud,
                contentBody,
                cargando: false,

            })
        }
        else {
            setstateinformacionModalAnularVacaciones(defaultSateInformacionModalAnularVacaciones)
            //alertService.error(respuestaUrlFormulario.errorMessage);
            showAlert(respuestaUrlFormulario.errorMessage, ErrorSVG, true);
        }





    }

    async function onClickAprobarSolicitudReintegro(informacionAcciones) {

        setstateinformacionModalAprobarReintegroVacaciones({
            ...stateinformacionModalAnularVacaciones,
            cargando: true,

        })

        const respuestaUrlFormulario = await DirectivoAprobadorObtenerVistaPreviaFormularioReintegroVacaciones(informacionAcciones.idSolicitud);
        const respuestaUrlDetallePlanificaciones = await ObtenerDetalleSolicitudReplanificacion(informacionAcciones.idSolicitud, "reintegro");


        const informacionReprogramacion = respuestaUrlDetallePlanificaciones.dataResponse !== null ? respuestaUrlDetallePlanificaciones.dataResponse : undefined;

        if (respuestaUrlFormulario.status === 200) {
            const contentBody = AuxiliarGenerarHTMLBodyModalReintegroVacaciones(informacionAcciones, respuestaUrlFormulario.dataResponse, informacionReprogramacion)
            setstateinformacionModalAprobarReintegroVacaciones({
                idSolicitudReintegro: informacionAcciones.idSolicitud,
                contentBody,
                cargando: false,

            })
        }
        else {
            setstateinformacionModalAprobarReintegroVacaciones(defaultSateInformacionModalAprobarReintegroVacaciones)
            //alertService.error(respuestaUrlFormulario.errorMessage);
            showAlert(respuestaUrlFormulario.errorMessage, ErrorSVG, true);
        }





    }

    async function OnClickAprobarSolicitudReplanificacionVacaciones(informacionAcciones) {
        setstateinformacionModalAprobarReplanificacion({
            ...stateinformacionModalAprobarReplanificacion,
            cargando: true,

        })

        const respuestaUrlFormulario = await DirectivoAprobadorObtenerVistaPreviaFormularioReplanificacionVacaciones(informacionAcciones.idSolicitud);
        const respuestaUrlDetallePlanificaciones = await ObtenerDetalleSolicitudReplanificacion(informacionAcciones.idSolicitud);


        if (respuestaUrlFormulario.status === 200 && respuestaUrlDetallePlanificaciones.status === 200) {
            const contentBody = AuxiliarGenerarHTMLBodyModalReplanificacionVacaciones(informacionAcciones, respuestaUrlFormulario.dataResponse, respuestaUrlDetallePlanificaciones.dataResponse)
            setstateinformacionModalAprobarReplanificacion({
                idSolicitudReplanificacion: informacionAcciones.idSolicitud,
                contentBody,
                cargando: false,

            })
        }
        else {
            setstateinformacionModalAprobarReintegroVacaciones(defaultSateInformacionModalAprobarReplanificacionVacaciones)
            //alertService.error(respuestaUrlFormulario.errorMessage);
            showAlert(respuestaUrlFormulario.errorMessage, ErrorSVG, true);
        }
    }

    async function OnClickAprobarParcialmenteSolicitudReplanificacionVacaciones(informacionAcciones) {
        setstateinformacionModalAprobarParcialmenteReplanificacion({
            ...stateinformacionModalAprobarParcialmenteReplanificacion,
            cargando: true,

        })

        const respuestaUrlDetallePlanificaciones = await ObtenerDetalleSolicitudReplanificacion(informacionAcciones.idSolicitud);


        if (respuestaUrlDetallePlanificaciones.status === 200) {
            const contentBody = AuxiliarGenerarHTMLBodyModalReplanificacionVacaciones(informacionAcciones, undefined, respuestaUrlDetallePlanificaciones.dataResponse);

            setstateinformacionModalAprobarParcialmenteReplanificacion({
                idSolicitudReplanificacion: informacionAcciones.idSolicitud,
                contentBody,
                cargando: false,

            })
        }
        else {
            setstateinformacionModalAprobarParcialmenteReplanificacion(defaultStateInformacionModalAprobarParcialmenteReplanificacionVacaciones)
            //alertService.error(respuestaUrlDetallePlanificaciones.errorMessage);
            showAlert(respuestaUrlDetallePlanificaciones.errorMessage, ErrorSVG, true);
        }
    }

    async function onClickRechazarReplanificacion(informacionAcciones) {
        setstateinformacionModalRechazarReplanificacion({
            ...setstateinformacionModalRechazarReplanificacion,
            cargando: true,

        })

        const respuestaUrlDetallePlanificaciones = await ObtenerDetalleSolicitudReplanificacion(informacionAcciones.idSolicitud);

        if (respuestaUrlDetallePlanificaciones.status === 200) {
            const contentBody = AuxiliarGenerarHTMLBodyModalReplanificacionVacaciones(informacionAcciones, undefined, respuestaUrlDetallePlanificaciones.dataResponse);

            setstateinformacionModalRechazarReplanificacion({
                idSolicitudReplanificacion: informacionAcciones.idSolicitud,
                contentBody,
                cargando: false,

            })
        }
        else {
            setstateinformacionModalRechazarReplanificacion(defaultStateInformacionModalRechazarReplanificacionVacaciones)
            //alertService.error(respuestaUrlDetallePlanificaciones.errorMessage);
            showAlert(respuestaUrlDetallePlanificaciones.errorMessage, ErrorSVG, true);
        }
    }



    const ModalAprobarSolicitudAnulacionVacaciones = useMemo(() => {
        return (
            <ModalConfirmacion
                show={stateinformacionModalAnularVacaciones.idSolicitudVacaciones > 0 || stateinformacionModalAnularVacaciones.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAnularVacaciones(defaultSateInformacionModalAnularVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar la solicitud de anulación vacaciones?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarAnulacionVacaciones(stateinformacionModalAnularVacaciones.idSolicitudVacaciones)}
                contentModal={stateinformacionModalAnularVacaciones.contentBody}
                tituloModal={"Solicitud de Anulación de Vacaciones"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}

            />

        )
    }, [stateinformacionModalAnularVacaciones])

    const ModalRechazarSolicitudAnulacionVacaciones = useMemo(() => {
        return (
            <ModalRechazo
                show={stateinformacionModalRechazarAnularVacaciones.idSolicitudVacaciones > 0 || stateinformacionModalRechazarAnularVacaciones.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazarAnularVacaciones(defaultSateInformacionModalRechazarAnularVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de anulación de vacaciones?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarAnulacionVacaciones(stateinformacionModalRechazarAnularVacaciones.idSolicitudVacaciones, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazarAnularVacaciones.contentBody}
                tituloModal={"Negar Solicitud de Anulación de Vacaciones"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={200}
            />
        )
    }, [stateinformacionModalRechazarAnularVacaciones])


    const ModalAprobarSolicitudReintegroVacaciones = useMemo(() => {

        if (stateinformacionModalAprobarReintegroVacaciones.cargando) {
            return <ModalCargando show={stateinformacionModalRechazarReintegroVacaciones.cargando} size="lg" onClose={() => { }} />
        }
        else {
            return (
                <ModalConfirmacion
                    show={stateinformacionModalAprobarReintegroVacaciones.idSolicitudReintegro > 0}
                    size="lg"
                    onClose={() => setstateinformacionModalAprobarReintegroVacaciones(defaultSateInformacionModalAprobarReintegroVacaciones)}
                    asyncAccion={true}
                    asyncClose={true}
                    closeAfterAccion={true}
                    hideBotonCerrar={false}
                    mensajeConfirmacion={"¿Está seguro/a que desea aprobar la solicitud de reintegro de vacaciones?"}
                    nombreBotonAccion={"SI"}
                    nombreBotonCerrarModal={"NO"}
                    asyncOnClick={() => AprobarReintegroVacaciones(stateinformacionModalAprobarReintegroVacaciones.idSolicitudReintegro)}
                    contentModal={stateinformacionModalAprobarReintegroVacaciones.contentBody}
                    tituloModal={"Solicitud de Reintegro de Vacaciones"}
                    asyncAfterOnClose={() => recargarInformacionTabla()}
                    botonesAccionParteSuperior={true}
                    classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                    classNameContentModal={"contentModalAprSolReintegroVacaciones"}
                />

            )
        }

    }, [stateinformacionModalAprobarReintegroVacaciones])


    const ModalRechazarSolicitudReintegroVacaciones = useMemo(() => {
        return (
            <ModalRechazo
                show={stateinformacionModalRechazarReintegroVacaciones.idSolicitudReintegro > 0 || stateinformacionModalRechazarReintegroVacaciones.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazarReintegroVacaciones(defaultSateInformacionModalRechazarReintegroVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de reintegro de vacaciones?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarReintegroVacaciones(stateinformacionModalRechazarReintegroVacaciones.idSolicitudReintegro, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazarReintegroVacaciones.contentBody}
                tituloModal={"Negar Solicitud de Reintegro de Vacaciones"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={200}
                cargando={stateinformacionModalRechazarReintegroVacaciones.cargando}

            />
        )
    }, [stateinformacionModalRechazarReintegroVacaciones])

    const ModalAprobarSolicitudReplanificacionVacaciones = useMemo(() => {
        return (
            <ModalConfirmacion
                show={stateinformacionModalAprobarReplanificacion.idSolicitudReplanificacion > 0 || stateinformacionModalAprobarReplanificacion.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAprobarReplanificacion(defaultSateInformacionModalAprobarReplanificacionVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar la solicitud ?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarReplanificacionVacaciones(stateinformacionModalAprobarReplanificacion.idSolicitudReplanificacion)}
                contentModal={stateinformacionModalAprobarReplanificacion.contentBody}
                tituloModal={"Solicitud de Reprogramación y/o Justificación de Vacaciones"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}

            />

        )
    }, [stateinformacionModalAprobarReplanificacion])

    const ModalAprobarParcialmenteSolicitudReplanificacionVacaciones = useMemo(() => {
        return (
            <ModalConfirmacion
                show={stateinformacionModalAprobarParcialmenteReplanificacion.idSolicitudReplanificacion > 0 || stateinformacionModalAprobarParcialmenteReplanificacion.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAprobarParcialmenteReplanificacion(defaultStateInformacionModalAprobarParcialmenteReplanificacionVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar la solicitud ?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarParcialmenteReplanificacionVacaciones(stateinformacionModalAprobarParcialmenteReplanificacion.idSolicitudReplanificacion)}
                contentModal={stateinformacionModalAprobarParcialmenteReplanificacion.contentBody}
                tituloModal={stateinformacionModalAprobarParcialmenteReplanificacion.tituloModal}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}

            />

        )
    }, [stateinformacionModalAprobarParcialmenteReplanificacion])

    const ModalRechazarSolicitudReplanificacionVacaciones = useMemo(() => {
        return (
            <ModalRechazo
                show={stateinformacionModalRechazarReplanificacion.idSolicitudReplanificacion > 0 || stateinformacionModalRechazarReplanificacion.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazarReplanificacion(defaultStateInformacionModalRechazarReplanificacionVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud ?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarSolicitudReplanificacionVacaciones(stateinformacionModalRechazarReplanificacion.idSolicitudReplanificacion, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazarReplanificacion.contentBody}
                tituloModal={"Negar Solicitud de Reprogramación de Vacaciones"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={200}
            />
        )
    }, [stateinformacionModalRechazarReplanificacion])


    const onClickRechazarSolicitudVacaciones = (informacionAcciones) => {

        const contentBody = AuxiliarGenerarHTMLBodyModalVacaciones(informacionAcciones);

        setstateinformacionModalRechazarVacaciones({
            cargando: false,
            idSolicitudVacaciones: informacionAcciones.idSolicitud,
            contentBody,
            observacion

        })
    }



    async function RechazarVacaciones(idSolicitud, observacion) {
        const respuesta = await RechazarSolicitudVacaciones(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            //alertService.error(respuesta.errorMessage)
            showAlert(respuesta.errorMessage, ErrorSVG, true);
        }
        else {
            //alertService.success("Se ha negado la solicitud de vacaciones");
            showAlert("Se ha negado la solicitud de vacaciones", ExitoSVG, true);

        }
    }


    function onClickRechazarAnulacionSolicitudVacaciones(informacionAcciones) {

        const contentBody = AuxiliarGenerarHTMLBodyModalVacaciones(informacionAcciones);

        setstateinformacionModalRechazarAnularVacaciones({
            cargando: false,
            idSolicitudVacaciones: informacionAcciones.idSolicitud,
            contentBody,
            observacion

        })
    }

    async function RechazarAnulacionVacaciones(idSolicitud, observacion) {
        const respuesta = await RechazarSolicitudAnulacionVacaciones(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            //alertService.error(respuesta.errorMessage)
            showAlert(respuesta.errorMessage, ErrorSVG, true);
        }
        else {
            //alertService.success("Se ha negado la solicitud de anulación vacaciones");
            showAlert("Se ha negado la solicitud de anulación vacaciones", ExitoSVG, true);


        }
    }

    async function onClickRechazarReintegroVacaciones(informacionAcciones) {

        setstateinformacionModalRechazarReintegroVacaciones({
            cargando: true,
        })

        const respuestaUrlDetallePlanificaciones = await ObtenerDetalleSolicitudReplanificacion(informacionAcciones.idSolicitud, "reintegro");


        const informacionReprogramacion = respuestaUrlDetallePlanificaciones.dataResponse !== null ? respuestaUrlDetallePlanificaciones.dataResponse : undefined;

        if (respuestaUrlDetallePlanificaciones.status === 200) {
            const contentBody = AuxiliarGenerarHTMLBodyModalReintegroVacaciones(informacionAcciones, undefined, informacionReprogramacion)
            setstateinformacionModalRechazarReintegroVacaciones({
                idSolicitudReintegro: informacionAcciones.idSolicitud,
                contentBody,
                cargando: false,

            })
        }
        else {
            setstateinformacionModalRechazarReintegroVacaciones(defaultSateInformacionModalRechazarReintegroVacaciones)
            //alertService.error(respuestaUrlDetallePlanificaciones.errorMessage);
            showAlert(respuestaUrlDetallePlanificaciones.errorMessage, ErrorSVG, true);
        }

    }

    async function RechazarSolicitudReplanificacion(idSolicitud, observacion) {
        const respuesta = await RechazarSolicitudAnulacionVacaciones(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            //alertService.error(respuesta.errorMessage)
            showAlert(respuesta.errorMessage, ErrorSVG, true);
        }
        else {
            //alertService.success("Se ha negado la solicitud de anulación vacaciones");
            showAlert("Se ha negado la solicitud de anulación vacaciones", ExitoSVG, true);
        }
    }

    function onClickAprobacionMasiva(solicitudesVacacionesAprobar) {

        const contentBody = (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Tipo Solicitud </th>
                            <th> Fecha Solicitud</th>

                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Estado</th>
                            <th> Días Ordinarios</th>

                        </tr>
                    </thead>
                    <tbody>

                        {solicitudesVacacionesAprobar.map((solicitudes, ind) => {
                            const informacionAcciones = solicitudes.acciones;
                            return (
                                <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                    <td>
                                        <div>
                                            {informacionAcciones.tiposolicitud}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.nombres}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
                                        </div>

                                    </td>

                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.estadoParse}
                                        </div>

                                    </td>


                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.diaOrdinario + " día(s) ordinario(s)"}
                                        </div>

                                    </td>

                                </tr>
                            )
                        })}

                    </tbody>
                </Table>
            </>

        )

        setstateModalAprobacionMasivaSolicitudVacaciones({
            cargando: false,
            listadoSolicitudesAprobar: solicitudesVacacionesAprobar,
            contentBody


        })
    }



    const ModalAprobacionMasivaSolicitudVacaciones = useMemo(() => {
        return (
            <ModalConfirmacion
                show={stateModalAprobacionMasivaSolicitudVacaciones.listadoSolicitudesAprobar.length > 0}
                size="lg"
                onClose={() => setstateModalAprobacionMasivaSolicitudVacaciones(defaultSateModalAprobacionMasivaSolicitudVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar las siguientes solicitudes"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarMasivaSolicitudVacaciones(stateModalAprobacionMasivaSolicitudVacaciones.listadoSolicitudesAprobar)}
                contentModal={stateModalAprobacionMasivaSolicitudVacaciones.contentBody}
                tituloModal={"Aprobación masiva solicitudes"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}

            />


        )
    }, [stateModalAprobacionMasivaSolicitudVacaciones])




    async function RechazarReintegroVacaciones(idSolicitud, observacion) {
        const respuesta = await RechazarSolicitudReintegroVacaciones(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            //alertService.error(respuesta.errorMessage)
            showAlert(respuesta.errorMessage, ErrorSVG, true);
        }
        else {
            //alertService.success("Se ha negado la solicitud de reintegro de vacaciones");
            showAlert("Se ha negado la solicitud de reintegro de vacaciones", ExitoSVG, true);

        }
    }

    function AuxiliarGenerarHTMLBodyModalVacaciones(informacionAcciones) {
        const esPermisoPorHora = informacionAcciones.horaDesde !== "" && informacionAcciones.horaHasta !== "" && informacionAcciones.horasTotal !== "";
        const contentBody = (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            {
                                !esPermisoPorHora &&
                                (
                                    <>
                                        <th> Fecha Desde</th>
                                        <th> Fecha Hasta</th>
                                    </>

                                )
                            }
                            {
                                esPermisoPorHora &&
                                (
                                    <>
                                        <th> Fecha </th>
                                        <th> Hora Desde </th>
                                        <th> Hora Hasta </th>
                                        <th> Total Horas </th>
                                    </>
                                )
                            }

                            <th> Estado</th>
                            <th> Días Ordinarios</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>

                            </td>
                            {
                                !esPermisoPorHora &&
                                (
                                    <>
                                        <td className="">
                                            <div className="">
                                                {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                            </div>

                                        </td>
                                        <td className="">
                                            <div className="">
                                                {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
                                            </div>

                                        </td>
                                    </>

                                )
                            }

                            {
                                esPermisoPorHora &&
                                (
                                    <>
                                        <td className="">
                                            <div className="">
                                                {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                            </div>

                                        </td>
                                        <td className="">
                                            <div className="">
                                                {informacionAcciones.horaDesde}
                                            </div>
                                        </td>
                                        <td className="">
                                            <div className="">
                                                {informacionAcciones.horaHasta}
                                            </div>
                                        </td>
                                        <td className="">
                                            <div className="">
                                                {informacionAcciones.horasTotal}
                                            </div>
                                        </td>
                                    </>

                                )
                            }



                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>

                            </td>


                            <td className="">
                                <div className="">
                                    {informacionAcciones.diaOrdinario + " día(s) ordinario(s)"}
                                </div>

                            </td>

                        </tr>

                    </tbody>
                </Table>
            </>

        )

        return contentBody;
    }

    function AuxiliarGenerarHTMLBodyModalInformacionVacacionesPendientes(informacionAcciones) {
        const contentBody = (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Días Vacaciones</th>
                            <th> Días Pendientes</th>
                            <th> Estado</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
                                </div>

                            </td>

                            <td className="">
                                <div className="">
                                    {informacionAcciones.diaOrdinario + " día(s) ordinario(s)"}
                                </div>

                            </td>

                            <td className="">
                                <div className="">
                                    {informacionAcciones.diasPendientes + " día(s) ordinario(s)"}
                                </div>

                            </td>



                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>

                            </td>




                        </tr>

                    </tbody>
                </Table>
            </>

        )

        return contentBody;
    }

    function AuxiliarGenerarHTMLBodyModalReintegroVacaciones(informacionAcciones, urlArchivo, detalleReplanificacion) {

        const { listadoPlanificacionesAnteriores, listadoReplanificaciones } = detalleReplanificacion;

        var tablaPlanificacionesAnteriores = undefined;
        var tablaReplanificaciones = undefined;

        if (detalleReplanificacion !== undefined && listadoPlanificacionesAnteriores !== undefined && listadoReplanificaciones !== undefined) {

            tablaPlanificacionesAnteriores = GenerarTablaPlanificacionesAnteriores(listadoPlanificacionesAnteriores);
            tablaReplanificaciones = GenerarTablaReplanificaciones(listadoReplanificaciones);

        }



        const contentBody = (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Estado</th>
                            <th> Días a reintegrarse</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaReintegro)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>

                            </td>


                            <td className="">
                                <div className="">
                                    {informacionAcciones.diaOrdinario + " día(s) ordinario(s)"}
                                </div>

                            </td>

                        </tr>

                    </tbody>
                </Table>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Observación/Motivo</Label>
                            <Input
                                id="observacionRechazo"
                                name="observacionRechazo"
                                type="textarea"
                                rows="5"
                                value={informacionAcciones.observacion}
                                readOnly
                                maxLength={500}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                {
                    listadoPlanificacionesAnteriores !== undefined && listadoPlanificacionesAnteriores.length > 0 &&
                    <>
                        <Row>
                            <Col>
                                {"Planificaciones anteriores"}
                            </Col>
                        </Row>
                        {tablaPlanificacionesAnteriores}
                    </>
                }
                {
                    listadoReplanificaciones !== undefined && listadoReplanificaciones.length > 0 &&
                    <>
                        <Row>
                            <Col>
                                {"Nueva planificación"}
                            </Col>
                        </Row>
                        {tablaReplanificaciones}
                    </>
                }
                {urlArchivo !== undefined &&
                    <Row>
                        <Col>
                            <PDFViewer url={urlArchivo} heightValue={"100%"} />

                        </Col>
                    </Row>
                }

            </>

        )

        return contentBody;
    }


    function GenerarTablaPlanificacionesAnteriores(listadoPlanificacionesAnteriores) {

        const tablaPlanificacionesAnteriores = (
            <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                <thead className="cabecerasDetallehistorialSolic">
                    <tr className="" >
                        <th> F. Desde</th>
                        <th> F. Hasta</th>
                        <th> Días </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        listadoPlanificacionesAnteriores.map((pl, ipl) => {
                            return (
                                <tr key={"plAnterior " + ipl} className="rowHistorialSolicitudVacaciones">
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(pl.fechaInicio)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(pl.fechaFin)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {pl.diasOrdinarios + " día(s) ordinario(s)"}
                                        </div>
                                    </td>

                                </tr>
                            )
                        })
                    }


                </tbody>
            </Table>
        )

        return tablaPlanificacionesAnteriores
    }

    function GenerarTablaReplanificaciones(listadoReplanificaciones) {

        const tablaReplanificaciones = (
            <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                <thead className="cabecerasDetallehistorialSolic">
                    <tr className="" >
                        <th> F. Desde</th>
                        <th> F. Hasta</th>
                        <th> Días </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        listadoReplanificaciones.map((pl, ipl) => {
                            return (
                                <tr key={"plReplanificaciones " + ipl} className="rowHistorialSolicitudVacaciones">
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(pl.fechaInicio)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(pl.fechaFin)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {pl.diasOrdinarios + " día(s) ordinario(s)"}
                                        </div>
                                    </td>

                                </tr>
                            )
                        })
                    }


                </tbody>
            </Table>
        )

        return tablaReplanificaciones
    }

    function AuxiliarGenerarHTMLBodyModalReplanificacionVacaciones(informacionAcciones, urlArchivo, detalleReplanificacion) {

        const { listadoPlanificacionesAnteriores, listadoReplanificaciones, listadoNoEjecutadas, nombres, fechaSolicitud, justificacionNoEjecutadas } = detalleReplanificacion;

        const tablaPlanificacionesAnteriores = GenerarTablaPlanificacionesAnteriores(listadoPlanificacionesAnteriores);

        const tablaReplanificaciones = GenerarTablaReplanificaciones(listadoReplanificaciones)


        const contentBody = (
            <>



                {urlArchivo !== undefined &&
                    <Row>
                        <Col>
                            <PDFViewer url={urlArchivo} heightValue={"100%"} />

                        </Col>
                    </Row>
                }

            </>

        )

        return (
            <>
                {
                    listadoPlanificacionesAnteriores.length > 0 &&
                    <>
                        <Row>
                            <Col>
                                {"Planificaciones anteriores"}
                            </Col>
                        </Row>
                        {tablaPlanificacionesAnteriores}
                    </>
                }
                {
                    listadoReplanificaciones.length > 0 &&
                    <>
                        <Row>
                            <Col>
                                {"Nueva planificación"}
                            </Col>
                        </Row>
                        {tablaReplanificaciones}
                    </>
                }
                {contentBody}
            </>
        );
    }



    function GenerarCellAcciones(informacionAcciones) {
        if (informacionAcciones === undefined || informacionAcciones === null) {
            return <span></span>
        }
        else if ((informacionAcciones.tiposolicitud === TipoSolicitud.VACACIONES || informacionAcciones.tiposolicitud === TipoSolicitud.PERMISOCARGOVACACIONES) && (informacionAcciones.estado === EstadoSolicitudVacaciones.INGRESO || informacionAcciones.estado === EstadoSolicitudVacaciones.APROBACIONPARCIALUNIDAD) && informacionAcciones.aprueba === "S") {

            // const iconoAprobar = (
            //     <i
            //         className="fa-regular fa-circle-check acciones"
            //         data-toggle="tooltip" data-placement="top" title="Aprobar"

            //         onClick={() => onClickAprobarSolicitudVacaciones(informacionAcciones)}
            //     >
            //     </i>
            // )

            const iconoAprobar = (
                <Aprobar
                    onClick={() => onClickAprobarSolicitudVacaciones(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Aprobar"
                    className={"acciones"}
                />

            )

            const iconoNegar = (
                <Negar
                    onClick={() => onClickRechazarSolicitudVacaciones(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Negar"
                    className={"acciones"}
                />
            )


            const contentAccion = (
                <React.Fragment>
                    <div className="containerIconosAccionAprobar">
                        {iconoAprobar}
                        {iconoNegar}
                    </div>


                </React.Fragment>
            )

 
            return contentAccion

        }
        else if ((informacionAcciones.tiposolicitud === TipoSolicitud.VACACIONES || informacionAcciones.tiposolicitud === TipoSolicitud.PERMISOCARGOVACACIONES) && informacionAcciones.estado === EstadoSolicitudVacaciones.INGRESO && informacionAcciones.aprueba === "N") {
            // const iconoAprobar = (
            //     <i
            //         className="fa-regular fa-circle-check acciones"
            //         onClick={() => onClickAprobarParcialmenteSolicitudVacaciones(informacionAcciones)}
            //         data-toggle="tooltip" data-placement="top" title="Aprobar"

            //     >
            //     </i>
            // )
            // const contentAccion = (
            //     <React.Fragment>


            //         {iconoAprobar}
            //         <i onClick={() => onClickRechazarSolicitudVacaciones(informacionAcciones)}
            //             className="fa-regular fa-circle-xmark ml-2 acciones"
            //             data-toggle="tooltip" data-placement="top" title="Negar"

            //         >
            //         </i>

            //     </React.Fragment>
            // )

            const iconoAprobar = (
                <Aprobar
                    onClick={() => onClickAprobarParcialmenteSolicitudVacaciones(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Aprobar"
                    className={"acciones"}
                />

            )

            const iconoNegar = (
                <Negar
                    onClick={() => onClickRechazarSolicitudVacaciones(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Negar"
                    className={"acciones"}
                />
            )

            const contentAccion = (
                <React.Fragment>
                    <div className="containerIconosAccionAprobar">
                        {iconoAprobar}
                        {iconoNegar}
                    </div>


                </React.Fragment>
            )

            


            return contentAccion
        }
        else if (informacionAcciones.tiposolicitud === TipoSolicitud.ANULACIONVACACIONES && informacionAcciones.estado === EstadoSolicitudVacaciones.REVERSOUNIDAD) {
            // const iconoAprobar = (
            //     <i
            //         className="fa-regular fa-circle-check acciones"
            //         onClick={() => onClickAnularSolicitudVacacionesAprobada(informacionAcciones)}
            //         data-toggle="tooltip" data-placement="top" title="Aprobar"

            //     >
            //     </i>
            // )
            // const contentAccion = (
            //     <React.Fragment>


            //         {iconoAprobar}
            //         <i onClick={() => onClickRechazarAnulacionSolicitudVacaciones(informacionAcciones)}
            //             data-toggle="tooltip" data-placement="top" title="Negar"

            //             className="fa-regular fa-circle-xmark ml-2 acciones" ></i>

            //     </React.Fragment>
            // )

            const iconoAprobar = (
                <Aprobar
                    onClick={() => onClickAnularSolicitudVacacionesAprobada(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Aprobar"
                    className={"acciones"}
                />

            )

            const iconoNegar = (
                <Negar
                    onClick={() => onClickRechazarAnulacionSolicitudVacaciones(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Negar"
                    className={"acciones"}
                />
            )

            const contentAccion = (
                <React.Fragment>
                    <div className="containerIconosAccionAprobar">
                        {iconoAprobar}
                        {iconoNegar}
                    </div>


                </React.Fragment>
            )

            


            return contentAccion
        }
        else if (informacionAcciones.tiposolicitud === TipoSolicitud.REINTEGROVACACIONES && informacionAcciones.estadoString === "P") {
            // const iconoAprobar = (
            //     <i
            //         className="fa-regular fa-circle-check acciones"
            //         onClick={() => onClickAprobarSolicitudReintegro(informacionAcciones)}
            //         data-toggle="tooltip" data-placement="top" title="Aprobar"

            //     >
            //     </i>
            // )
            // const contentAccion = (
            //     <React.Fragment>


            //         {iconoAprobar}
            //         <i onClick={() => onClickRechazarReintegroVacaciones(informacionAcciones)}
            //             data-toggle="tooltip" data-placement="top" title="Negar"

            //             className="fa-regular fa-circle-xmark ml-2 acciones" ></i>

            //     </React.Fragment>
            // )

            const iconoAprobar = (
                <Aprobar
                    onClick={() => onClickAprobarSolicitudReintegro(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Aprobar"
                    className={"acciones"}
                />

            )

            const iconoNegar = (
                <Negar
                    onClick={() => onClickRechazarReintegroVacaciones(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Negar"
                    className={"acciones"}
                />
            )

            const contentAccion = (
                <React.Fragment>
                    <div className="containerIconosAccionAprobar">
                        {iconoAprobar}
                        {iconoNegar}
                    </div>


                </React.Fragment>
            )
            return contentAccion
        }
        else if (informacionAcciones.tiposolicitud === TipoSolicitud.REPLANIFICACIONVACACIONES && (informacionAcciones.estado === EstadoSolicitudReplanificacionVacaciones.INGRESO || informacionAcciones.estado === EstadoSolicitudReplanificacionVacaciones.APROBADA_PARCIALMENTE) && informacionAcciones.aprueba === "S") {
            // const iconoAprobar = (
            //     <i
            //         className="fa-regular fa-circle-check acciones"
            //         onClick={() => OnClickAprobarSolicitudReplanificacionVacaciones(informacionAcciones)}
            //         data-toggle="tooltip" data-placement="top" title="Aprobar"

            //     >
            //     </i>
            // )
            // const contentAccion = (
            //     <React.Fragment>


            //         {iconoAprobar}
            //         <i onClick={() => onClickRechazarReplanificacion(informacionAcciones)}
            //             data-toggle="tooltip" data-placement="top" title="Negar"

            //             className="fa-regular fa-circle-xmark ml-2 acciones" ></i>

            //     </React.Fragment>
            // )

            const iconoAprobar = (
                <Aprobar
                    onClick={() => OnClickAprobarSolicitudReplanificacionVacaciones(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Aprobar"
                    className={"acciones"}
                />

            )

            const iconoNegar = (
                <Negar
                    onClick={() => onClickRechazarReplanificacion(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Negar"
                    className={"acciones"}
                />
            )

            const contentAccion = (
                <React.Fragment>
                    <div className="containerIconosAccionAprobar">
                        {iconoAprobar}
                        {iconoNegar}
                    </div>


                </React.Fragment>
            )
            return contentAccion
        }
        else if (informacionAcciones.tiposolicitud === TipoSolicitud.REPLANIFICACIONVACACIONES && informacionAcciones.estado === EstadoSolicitudReplanificacionVacaciones.INGRESO && informacionAcciones.aprueba === "N") {
            // const iconoAprobar = (
            //     <i
            //         className="fa-regular fa-circle-check acciones"
            //         onClick={() => OnClickAprobarParcialmenteSolicitudReplanificacionVacaciones(informacionAcciones)}
            //         data-toggle="tooltip" data-placement="top" title="Aprobar"

            //     >
            //     </i>
            // )
            // const contentAccion = (
            //     <React.Fragment>


            //         {iconoAprobar}
            //         <i onClick={() => onClickRechazarReplanificacion(informacionAcciones)}
            //             data-toggle="tooltip" data-placement="top" title="Negar"

            //             className="fa-regular fa-circle-xmark ml-2 acciones" ></i>

            //     </React.Fragment>
            // )

            const iconoAprobar = (
                <Aprobar
                    onClick={() => OnClickAprobarParcialmenteSolicitudReplanificacionVacaciones(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Aprobar"
                    className={"acciones"}
                />

            )

            const iconoNegar = (
                <Negar
                    onClick={() => onClickRechazarReplanificacion(informacionAcciones)}
                    data-toggle="tooltip" data-placement="top" title="Negar"
                    className={"acciones"}
                />
            )

            const contentAccion = (
                <React.Fragment>
                    <div className="containerIconosAccionAprobar">
                        {iconoAprobar}
                        {iconoNegar}
                    </div>


                </React.Fragment>
            )
            return contentAccion
        }
        else {
            return <div />
        }
    }

    const column_usando = React.useMemo(
        () => [
            {
                Header: "Tipo de Solicitud",
                accessor: "tipoSolicitud"
            },
            {
                Header: 'Fecha Solicitud',
                accessor: 'fechaSolicitud',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Nombres',
                accessor: 'nombres',
            },
            {
                Header: 'Fecha Desde',
                accessor: 'fechaDesde',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Fecha Hasta',
                accessor: 'fechaHasta',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Hora Desde',
                accessor: 'horaDesde',
            },
            {
                Header: 'Hora Hasta',
                accessor: 'horaHasta',
            },
            {
                Header: 'Horas',
                accessor: 'horasTotal',
            },
            {
                Header: 'Días Ordinarios',
                accessor: 'diaOrdinario',
            },
            {
                Header: 'Días Pendientes por Gozar',
                accessor: 'diasPendientesVacaciones',
            },
            {
                Header: 'Estado',
                accessor: 'estadoParse',
            },
            {
                Header: 'Observaciones',
                accessor: 'observacion',
            },
            {
                Header: "Acciones",
                accessor: 'acciones',
                Cell: ({ value }) => GenerarCellAcciones(value)
            }
        ], [dataprops]
    )


    function ShowCheckBoxCondition(dataRow) {
        return dataRow && TIPO_SOLICITUDES_APROBAR_MASIVAMENTE.includes(dataRow.tipoSolicitud);
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        selectedFlatRows,
        prepareRow,
        state,
        setGlobalFilter,
        getToggleHideAllColumnsProps,
        getToggleAllPageRowsSelectedProps,
        toggleRowSelected

    } = useTable(
        {
            columns: column_usando,
            data
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [

                    ...columns,
                    {
                        id: 'selection',
                        Header: ({ getToggleAllPageRowsSelectedProps }) => (
                            <Checkbox
                                isHeader={true}
                                {...getToggleAllPageRowsSelectedProps()}
                            />
                        ),
                        Cell: ({ row }) => (
                            <Checkbox
                                condition={ShowCheckBoxCondition(row.values)}
                                {...row.getToggleRowSelectedProps()}

                            />
                        )

                    }
                ]
            })
        }
    )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = data.length;

    const columnasStyles = (cell) => {
        return ([
            {
                HeaderName: "Nombres",
                StyleHeader: {
                    textAlign: "left"
                }
            },
            {
                HeaderName: "Estado",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Días Ordinarios",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Días Pendientes por Gozar",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Tipo de Solicitud",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Fecha Desde",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Fecha Hasta",
                StyleHeader: {
                    textAlign: "center"
                }
            },
            {
                HeaderName: "Observaciones",
                StyleHeader: {
                    textAlign: "justify",
                    width: "200px"

                }
            }
        ])
    }



    const ButtonAprobacionMasiva = useMemo(() => {

        const nombreBotonAprobarMasivo = "Aprobar todas las solicitudes seleccionadas";
        if (selectedFlatRows.length === 1) {
            var filaSeleccionada = selectedFlatRows[0].original;
            if (TIPO_SOLICITUDES_APROBAR_MASIVAMENTE.includes(filaSeleccionada.tipoSolicitud)) {

                if (filaSeleccionada.aprueba === "S" && TIPO_SOLICITUDES_PERMISOS_VACACIONES.includes(filaSeleccionada.tipoSolicitud)) {

                    return <ButtonAprobarMasivo
                        onClick={() => onClickAprobarSolicitudVacaciones(filaSeleccionada.acciones)}
                        text='Aprobar Solicitud'
                    />

                    // return <Button className="fleft" onClick={() => onClickAprobarSolicitudVacaciones(filaSeleccionada.acciones)} >Aprobar Solicitud </Button>


                }
                else if (filaSeleccionada.aprueba !== "S" && TIPO_SOLICITUDES_PERMISOS_VACACIONES.includes(filaSeleccionada.tipoSolicitud)){
                    return <ButtonAprobarMasivo
                        onClick={() => onClickAprobarParcialmenteSolicitudVacaciones(filaSeleccionada.acciones)}
                        text='Aprobar Solicitud'
                    />
                    // return <Button className="fleft" onClick={() => onClickAprobarParcialmenteSolicitudVacaciones(filaSeleccionada.acciones)} >Aprobar Solicitud </Button>
                }
                else if (filaSeleccionada.aprueba === "S" && filaSeleccionada.tipoSolicitud === TipoSolicitud.REINTEGROVACACIONES){
                    return <ButtonAprobarMasivo
                        onClick={() => onClickAprobarSolicitudReintegro(filaSeleccionada.acciones)}
                        text='Aprobar Solicitud'
                    />
                }
                else if (filaSeleccionada.aprueba === "S" && filaSeleccionada.tipoSolicitud === TipoSolicitud.ANULACIONVACACIONES){
                    return <ButtonAprobarMasivo
                        onClick={() => onClickAnularSolicitudVacacionesAprobada(filaSeleccionada.acciones)}
                        text='Aprobar Solicitud'
                    />
                }
                
                else if (filaSeleccionada.aprueba === "S" && filaSeleccionada.tipoSolicitud === TipoSolicitud.REPLANIFICACIONVACACIONES){
                    return <ButtonAprobarMasivo
                        onClick={() => OnClickAprobarSolicitudReplanificacionVacaciones(filaSeleccionada.acciones)}
                        text='Aprobar Solicitud'
                    />
                }

                else if (filaSeleccionada.aprueba !== "S" && filaSeleccionada.tipoSolicitud === TipoSolicitud.REPLANIFICACIONVACACIONES){
                    return <ButtonAprobarMasivo
                        onClick={() => OnClickAprobarParcialmenteSolicitudReplanificacionVacaciones(filaSeleccionada.acciones)}
                        text='Aprobar Solicitud'
                    />
                }
            }
            else {
                return <Button className="fleft" disabled>Aprobar Solicitud </Button>
            }
        }

        else if (selectedFlatRows.length > 1) {
            var filasSeleccionadas = selectedFlatRows;
            var filasMapeadas = [];
            filasSeleccionadas.forEach(element => {
                if (TIPO_SOLICITUDES_APROBAR_MASIVAMENTE.includes(element.original.tipoSolicitud)) {
                    filasMapeadas.push(element.original)
                }
            });

            if (filasMapeadas.length > 0) {
                return <ButtonAprobarMasivo
                    onClick={() => onClickAprobacionMasiva(filasMapeadas)}
                    text={nombreBotonAprobarMasivo}
                />
                // return (<Button className="fleft" onClick={() => onClickAprobacionMasiva(filasMapeadas)} >{nombreBotonAprobarMasivo} </Button>)
            }
            else if (filasMapeadas.length <= 0) {
                return <ButtonAprobarMasivo
                    text={nombreBotonAprobarMasivo}
                    disabled={true}
                />
                // return (<Button className="fleft" disabled >{nombreBotonAprobarMasivo} </Button>)
            }
        }
        else {
            return <ButtonAprobarMasivo
                text={nombreBotonAprobarMasivo}
                disabled={true}
            />
            // return <Button className="fleft" disabled>{nombreBotonAprobarMasivo}</Button>
        }

    }, [selectedFlatRows])



    const ButtonFiltrarPermisosSolicitudesVacaciones = useMemo(() => {

        return (
            <>
                <Label>Seleccionar solicitudes de: </Label>
                <Input value={tipoFiltroSolicitud} type="select" onChange={(e) => filtrarTiposSolicitud(e.target.value)} >
                    <option value={TipoFiltroSolicitudAprobar.TODOS}>Todas las Solicitudes</option>
                    <option value={TipoFiltroSolicitudAprobar.VACACIONES}>Vacaciones y Permisos</option>
                    <option value={TipoFiltroSolicitudAprobar.PERMISOS}>Permisos y Licencias</option>
                </Input>
            </>

        )

        // return <Button className="fleft" onClick={() => filtrarTiposSolicitud(TipoFiltroSolicitudAprobar.VACACIONES_Y_PERMISOS)} >Mostrar Solicitudes de Vacaciones y Permisos </Button>
    }, [selectedFlatRows])


    return (
        <React.Fragment>
            {/* <Row>
                <Col xl={4}>
                    {ButtonFiltrarPermisosSolicitudesVacaciones}
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xl={12}>
                    <div className={"titulo_seccion"}>{"SOLICITUDES DE PERMISOS Y LICENCIAS"}</div>
                </Col>
            </Row> */}
            <Row>
                <Col xl={12}>
                    <div className="containerBtnAprobacionesVacLic">
                        <GlobalFilterTable
                            filter={globalFilter}
                            setFilter={setGlobalFilter}
                        />
                        {/* <div className='containerBotonAprobMasivaSolicitudes'> */}
                        {ButtonAprobacionMasiva}
                    </div>


                </Col>
            </Row>
            {/* <Row className={"mb-3 rowBotonFiltroAprobacionMasivaSolicitudes"}>

                <Col xl={2}>

                </Col>
                <Col xl={2}>
                    <div className='containerBotonAprobMasivaSolicitudes'>
                        {ButtonAprobacionMasiva}
                    </div>
                </Col>
            </Row> */}

            <Row className={"mb-2"}>

                <Col>
                    <p>{tipoFiltroSolicitud === TipoFiltroSolicitudAprobar.VACACIONES ? "Se estan mostrando las solicitudes de vacaciones y permisos imputable a vacaciones" : ""}</p>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            style={{ width: column.Header === "Observaciones" ? "300px" : "auto" }}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, columnasStyles(cell))

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}

                    />
                </Col>
            </Row>



            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalAprobarVacaciones.url !== "" || stateinformacionModalAprobarVacaciones.cargando}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalAprobarVacaciones.cargando}
                onClose={() => setstateinformacionModalAprobarVacaciones(defaultStateInformacionModalAprobarVacaciones)}
                size="xl"
                tituloModal={stateinformacionModalAprobarVacaciones.tituloModal}
                urlArchivo={stateinformacionModalAprobarVacaciones.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalAprobarVacaciones.idSolicitudVacaciones)}
                nombreBotonAccion={"Aprobar"}
                disabledbuttonCondition={stateinformacionModalAprobarVacaciones.cargando}
                // modalContent = {stateinformacionModalAprobarVacaciones.modalContent}
                modalContent={undefined}


            />

            {/* Aprobacion Parcial de Vacaciones */}
            <ModalConfirmacion
                show={stateinformacionModalAprobarParcialmenteVacaciones.idSolicitudVacaciones > 0 || stateinformacionModalAprobarParcialmenteVacaciones.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAprobarParcialmenteVacaciones(defaultStateInformacionModalAprobarParcialmenteVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar la solicitud de vacaciones?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarParcialmenteSolicitudVacaciones(stateinformacionModalAprobarParcialmenteVacaciones.idSolicitudVacaciones)}
                contentModal={stateinformacionModalAprobarParcialmenteVacaciones.contentBody}
                tituloModal={stateinformacionModalAprobarParcialmenteVacaciones.tituloModal}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                classNameAllModal={""}


            />

            <ModalRechazo
                show={stateinformacionModalRechazarVacaciones.idSolicitudVacaciones > 0 || stateinformacionModalRechazarVacaciones.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazarVacaciones(defaultStateInformacionModalRechazarVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de vacaciones?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarVacaciones(stateinformacionModalRechazarVacaciones.idSolicitudVacaciones, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazarVacaciones.contentBody}
                tituloModal={"Negar Solicitud de Vacaciones"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}

            />

            {ModalAprobarSolicitudAnulacionVacaciones}
            {ModalRechazarSolicitudAnulacionVacaciones}
            {ModalAprobarSolicitudReintegroVacaciones}
            {ModalRechazarSolicitudReintegroVacaciones}

            {ModalAprobarSolicitudReplanificacionVacaciones}
            {ModalAprobarParcialmenteSolicitudReplanificacionVacaciones}
            {ModalRechazarSolicitudReplanificacionVacaciones}

            {ModalAprobacionMasivaSolicitudVacaciones}

        </React.Fragment>
    )


}
